// Helper function to get avatar image path from preset name
export const getAvatarPath = (avatarPreset) => {
  if (!avatarPreset) return null;
  
  // Map preset names to image paths
  // Assuming avatars are stored in public/avatars/ directory
  const avatarMap = {
    'doge1': '/avatars/doge1.png',
    'doge2': '/avatars/doge2.png',
    'doge3': '/avatars/doge3.png',
    'doge4': '/avatars/doge4.png',
    'doge5': '/avatars/doge5.png',
    'doge6': '/avatars/doge6.png',
    'doge7': '/avatars/doge7.png',
    'doge8': '/avatars/doge8.png'
  };
  
  return avatarMap[avatarPreset] || null;
};

// Get avatar component (image or placeholder)
export const getAvatarComponent = (avatarPreset, size = 32) => {
  const avatarPath = getAvatarPath(avatarPreset);
  
  if (avatarPath) {
    return (
      <img 
        src={avatarPath}
        alt="Avatar"
        style={{
          width: `${size}px`,
          height: `${size}px`,
          borderRadius: '4px',
          border: '2px solid #000',
          objectFit: 'cover',
          background: '#f0f0f0'
        }}
        onError={(e) => {
          // Fallback to placeholder if image fails to load
          e.target.style.display = 'none';
          if (e.target.nextSibling) {
            e.target.nextSibling.style.display = 'flex';
          }
        }}
      />
    );
  }
  
  // Default placeholder
  return (
    <div
      style={{
        width: `${size}px`,
        height: `${size}px`,
        borderRadius: '4px',
        border: '2px solid #000',
        background: 'linear-gradient(135deg, #ffd700 0%, #ffed4e 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: `${size * 0.6}px`
      }}
    >
      🐕
    </div>
  );
};

